export default __webpack_public_path__ + "static/media/480_portfolio03-es-web.a3a081b7.png";